import { type ValidationRule } from '../../types';
import { ActionRequiredError } from '../../util/errors';

import { type CanonicalValidateArgs, CanonicalStepRuleBase } from './base';

class PushModeRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.PushMode', 'PushMode');
  }

  protected validate({ ctx }: CanonicalValidateArgs): void {
    if (ctx.isROS2Enabled) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message:
          'Push mode steps are not supported when ROS2 is enabled. Please remove this Push mode step from the routine.',
      });
    }
  }
}

export const PushModeValidation: ValidationRule =
  new PushModeRule().toValidationRule();
